// Display versions never replace the writable source fields on an entry.
export function recordText(record = {}, locale = 'en') {
  const original = { name: record.name || '', alternative_text: record.alternative_text || '', translated: false }
  const spanish = record.text_versions && record.text_versions['es-ES']
  if (!/^es(?:[-_]|$)/i.test(locale) || !spanish || !spanish.source
    || spanish.source.name !== original.name || spanish.source.alternative_text !== original.alternative_text
    || typeof spanish.name !== 'string' || typeof spanish.alternative_text !== 'string') return original

  return { name: spanish.name, alternative_text: spanish.alternative_text, translated: true }
}
